export default __webpack_public_path__ + "static/media/vili_s.4105eed6.jpg";